import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatRadioModule } from '@angular/material/radio'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatSelectModule } from '@angular/material/select'
import { NatureAndExtentOfValuersWorkComponent } from "./nature-and-extent-of-valuers-work.component";
import { AddScopeDialogComponent } from "./add-scope-dialog.component";
import { FormFieldStateModule } from "src/app/views/pages/mad_shared/form-field-state/form-field-state.module";
import { EditOptionDialogComponent } from "./edit-option-dialog.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    FormFieldStateModule,
    MatSelectModule
  ],
  declarations: [
    NatureAndExtentOfValuersWorkComponent,
    AddScopeDialogComponent,
    EditOptionDialogComponent,
  ],
  exports: [
    NatureAndExtentOfValuersWorkComponent
  ],
  providers: []
})
export class NatureAndExtentOfValuersWorkModule {}